import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Lightbulb, Heart, Smile, Shield, Sparkles } from 'lucide-react';
import { teamValues, heroImages } from '../siteContent';

const icons = { Lightbulb, Heart, Smile, Shield };

export default function APropos() {
  return (
    <div>
      <section className="relative">
        <div className="absolute inset-0 bg-cover bg-center opacity-25" style={{ backgroundImage: `url(${heroImages.aproposHero})` }} />
        <div className="absolute inset-0 bg-gradient-to-b from-neutral-950/60 to-neutral-950" />
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-28 text-center">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 rounded-full border border-yellow-400/30 bg-yellow-400/5 text-yellow-300 text-xs font-medium tracking-wider uppercase">
            <Sparkles size={14} /> À propos de nous
          </div>
          <h1 className="text-5xl md:text-6xl font-extrabold text-yellow-400 leading-[1.05]">
            L'équipe derrière la ruche
          </h1>
          <p className="mt-6 max-w-3xl mx-auto text-neutral-300 text-lg leading-relaxed">
            BuzzBump est né d'une envie simple : redécouvrir le plaisir de jouer avec ses amis dans la vraie vie, grâce à la magie du mobile. Une bande de passionnés, une idée folle, et une ambition claire — créer la prochaine grande app sociale française.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <div className="absolute -inset-6 bg-yellow-400/10 blur-3xl rounded-3xl" />
          <div className="relative rounded-2xl overflow-hidden border border-white/10">
            <img src={heroImages.aproposStory} alt="Équipe BuzzBump réunie" loading="lazy" className="w-full h-[460px] object-cover" />
          </div>
        </div>
        <div>
          <div className="text-yellow-400 text-sm font-semibold tracking-wider uppercase mb-3">Notre histoire</div>
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight">Une idée née entre amis</h2>
          <p className="mt-5 text-neutral-300 leading-relaxed">
            Tout a commencé par une soirée entre potes, un défi lancé à l'improviste, et une question : pourquoi ne pas transformer ce fun spontané en expérience mobile ? De là est né BuzzBump — une plateforme où chaque rue devient un terrain de jeu et chaque ami(e) un complice potentiel.
          </p>
          <p className="mt-4 text-neutral-300 leading-relaxed">
            Notre mission est de créer des moments inoubliables, des fous rires et des souvenirs partagés, le tout en respectant les valeurs essentielles de fair-play et de bienveillance.
          </p>
        </div>
      </section>

      <section className="bg-neutral-900/40 border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <div className="text-yellow-400 text-sm font-semibold tracking-wider uppercase mb-3">Nos valeurs</div>
            <h2 className="text-4xl font-bold text-white">Ce qui nous fait vibrer</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamValues.map((v) => {
              const Icon = icons[v.icon];
              return (
                <div key={v.title} className="p-7 rounded-2xl border border-white/10 bg-neutral-950/60 hover:border-yellow-400/30 hover:-translate-y-1 transition-all duration-300">
                  <div className="h-12 w-12 grid place-items-center rounded-md bg-yellow-400/15 text-yellow-400 mb-5">
                    <Icon size={22} />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{v.title}</h3>
                  <p className="text-neutral-400 leading-relaxed text-sm">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white">Une vision claire, une promesse simple.</h2>
          <p className="mt-5 text-neutral-400 max-w-2xl mx-auto leading-relaxed">
            Repousser les frontières du divertissement social mobile en proposant une expérience authentique, immersive et accessible à tous. Du fun, de l'adrénaline, et beaucoup de souvenirs à venir.
          </p>
          <Link to="/contact" className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-yellow-400 text-neutral-900 font-semibold hover:bg-yellow-300 transition-colors">
            Discutons ensemble <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
